import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './Breadcrumbs.scss';

var Breadcrumbs = /*#__PURE__*/function (_Component) {
  _inherits(Breadcrumbs, _Component);

  var _super = _createSuper(Breadcrumbs);

  function Breadcrumbs() {
    _classCallCheck(this, Breadcrumbs);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumbs, [{
    key: "render",
    value: function render() {
      var cleanCrumbs = this.props.crumbs.filter(function (c) {
        return c !== '';
      });
      var zeroIndexedCrumbLength = cleanCrumbs.length - 1;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        style: {
          marginTop: 6
        },
        className: styles.breadCrumbWrap
      }, cleanCrumbs.map(function (crumb, index) {
        return /*#__PURE__*/React.createElement("span", {
          className: styles.crumb,
          key: index
        }, crumb, " ", /*#__PURE__*/React.createElement("span", {
          className: styles.caret
        }, index < zeroIndexedCrumbLength && '>'));
      })));
    }
  }]);

  return Breadcrumbs;
}(Component);

export { Breadcrumbs as default };